import { Alert } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'

type Props = {
  templateId: string
}

export const HiddenTemplateViewer = ({ templateId }: Props) => {
  const translate = useTranslate()

  return (
    <div className="p-2 flex size-full justify-center items-center">
      <Alert
        severity="info"
        title={translate('templateViewer.hiddenTemplate', {
          templateId,
        })}
      />
    </div>
  )
}
